import React, { useState } from 'react'

const Footer = () => {

    const [formData, setFormData] = useState({
        email: '',
      });
    
      const handleChange = (e) => {
        setFormData({
          ...formData,
          [e.target.name]: e.target.value
        });
      };
    
      const handleSubmit = async (e) => {
        e.preventDefault();
        try {
          const response = await fetch('https://server.phgafrica.org/add-subscriber', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(formData)
          });
    
          if (response.ok) {
            const data = await response.json();
            alert(`Subscribed successfully! Welcome aboard.`);
            window.location.href = '/';
            
          } else {
            alert('Error submitting form. Please try again.');
          }
        } catch (error) {
          alert(`Network error: ${error.message || error}`);
        }
      };


  return (
        <div style={{color:'rgb(79, 79, 79)'}} className="container-fluid footer py-5 wow fadeIn" data-wow-delay="0.2s">
            <div className="container py-5">
                <div className="row g-5 mb-5 align-items-center">
                    <div className="col-lg-7">
                        <div className="position-relative mx-auto">
                            <form onSubmit={handleSubmit}>
                            <input className="form-control rounded-pill w-100 py-3 ps-4 pe-5" value={formData.email} name='email' onChange={handleChange} type="email" placeholder="Email address to Subscribe" />
                            <input type="submit" value="Subscribe" className="btn btn-secondary rounded-pill position-absolute top-0 end-0 py-2 px-4 mt-2 me-2" />
                            </form>
                        </div>
                    </div>
                    <div className="col-lg-5">
                        <div className="d-flex align-items-center justify-content-center justify-content-lg-end">
                            {/* Add real social URLs when available */}
                            <a className="btn btn-secondary btn-md-square rounded-circle me-3" href="https://facebook.com" target="_blank" rel="noreferrer"><i className="fab fa-facebook-f"></i></a>
                            <a className="btn btn-secondary btn-md-square rounded-circle me-3" href="https://twitter.com" target="_blank" rel="noreferrer"><i className="fab fa-twitter"></i></a>
                            <a className="btn btn-secondary btn-md-square rounded-circle me-3" href="https://instagram.com" target="_blank" rel="noreferrer"><i className="fab fa-instagram"></i></a>
                            <a className="btn btn-secondary btn-md-square rounded-circle me-0" href="https://linkedin.com" target="_blank" rel="noreferrer"><i className="fab fa-linkedin-in"></i></a>
                        </div>
                    </div>
                </div>
                <div className="row g-5">
                    <div className="col-md-6 col-lg-6 col-xl-3">
                        <div className="footer-item d-flex flex-column">
                            <div className="footer-item">
                                <h3 className="text-white mb-4"><img src="img/logo.png" height="70px" width="100px" alt="PHG Africa Logo" />PHG Africa</h3>
                                <p className="mb-3">We deliver Sustainable Rural Development and Digital Research Projects in Africa focusing on Grassroot Innovation Development, Digital Skills Training, Community Health Promotion Innovation, AgriInnovates Sustainability Projects, Women, Youth &amp; Persons Living with Disability (PwDs) Programmes</p>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6 col-lg-6 col-xl-3">
                        <div className="footer-item d-flex flex-column">
                            <h4 className="text-white mb-4">Useful Links</h4>
                            <a href="#"><i className="fas fa-angle-right me-2"></i> Home</a>
                            <a href="#"><i className="fas fa-angle-right me-2"></i> About</a>
                            <a href="#"><i className="fas fa-angle-right me-2"></i>Become a Volunteer</a>
                            <a href="#"><i className="fas fa-angle-right me-2"></i>Donate</a>
                            <a href="#"><i className="fas fa-angle-right me-2"></i> Contact us</a>
                            <a href="#"><i className="fas fa-angle-right me-2"></i> Terms &amp; Conditions</a>
                        </div>
                    </div>
                    <div className="col-md-6 col-lg-6 col-xl-3">
                        <div className="footer-item d-flex flex-column">
                            <h4 className="text-white mb-4">Business Hours</h4>
                            <div className="mb-3">
                                <h6 className="text-muted mb-0">Mon - Friday:</h6>
                                <p className="text-white mb-0">08.00 am to 05.00 pm</p>
                            </div>
                            <div className="mb-3">
                                <h6 className="text-muted mb-0">Saturday:</h6>
                                <p className="text-white mb-0">09.00 am to 04.00 pm</p>
                            </div>
                            <div className="mb-3">
                                <h6 className="text-muted mb-0">But you can reach us:</h6>
                                <p className="text-white mb-0">All our digital channels</p>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6 col-lg-6 col-xl-3">
                        <div className="footer-item d-flex flex-column">
                            <h4 className="text-white mb-4">Contact Info</h4>
                            <a href="#"><i className="fa fa-map-marker-alt me-2"></i> Top - High, Kumasi, Ashanti Region - Ghana</a>
                            <a href="mailto:info@phgfoundationafrica.org"><i className="fas fa-envelope me-2"></i> info@phgfoundationafrica.org</a>
                            <a href="tel:+233242029161"><i className="fas fa-phone me-2"></i> +233 242 029 161</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
  )
}

export default Footer